import * as Sentry from '@sentry/browser';
import type { DeviceInterface } from '@sfstudios/shapeshifter';
import { brand } from './brand';
import { getOsVersion } from './deviceInfo';

export const applyDeviceContext = (device: DeviceInterface) => {
  const osVersion = getOsVersion(device) ?? 'unknown';

  Sentry.setTag('brand', brand);
  Sentry.setTag('platform', device.manufacturer);
  Sentry.setTag('model', device.model);
  Sentry.setTag('os_version', osVersion);
  Sentry.setTag('platform_version', `${device.manufacturer}-${osVersion}`);
  Sentry.setUser({ id: device.id });
};
